import * as React from 'react';
import { Component } from 'react';
import { observer } from 'mobx-react';
import { withTheme } from 'styled-components';
import { styled } from '../utils/styled';
import { propStyles } from '../utils/propStyles';
import { Theme } from '../models/Theme';
import { inject } from '../utils';
import { DataStore } from '../stores';
import { createPortal } from 'react-dom';

const Layer = styled<any, any>('div', 'layer', 'clickLayer')`
    ${propStyles};
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: ${props =>
        props.obscure ? 'rgba(0, 0, 0, 0.45)' : 'transparent'};
`;

Layer.defaultProps = {
    zIndex: 'clicklayer',
    obscure: false,
};

interface ClickLayerProps {
    theme?: Theme;
    'data-metric-id'?: string;
    onClick: (e) => void;
    obscure?: boolean;
    dataStore?: DataStore;
}

@inject('dataStore')
@observer
class ClickLayer extends Component<ClickLayerProps> {
    render() {
        const { dataStore } = this.props;
        if (!dataStore) {
            return null;
        }
        const clickLayerElement = dataStore.shadowRoot.getElementById(
            'fundcenter-click-layer'
        );

        return createPortal(<Layer {...this.props} />, clickLayerElement);
    }
}

export default withTheme(ClickLayer);



// WEBPACK FOOTER //
// ./src/Components/ClickLayer.tsx